import { useDashboardAudience } from './dashboardAudience'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  SortableTableHead,
} from '@/components/ui/table'
import { displayDate } from '@/lib/dates'
import type { PortalSpendRow } from './portalSpend.types'
import { BilledTo, PortalInvoiceRow, portalInvoicePath } from './portalSpendCells'

export function PortalSpendTable({
  rows,
  sort,
  onSort,
}: {
  rows: PortalSpendRow[]
  sort: string
  onSort: (sort: string) => void
}) {
  const audience = useDashboardAudience(0)
  const [field, direction] = sort.split(':')
  const sortHead = (id: string, label: string, right = false) => (
    <SortableTableHead
      active={field === id}
      direction={direction === 'desc' ? 'descending' : 'ascending'}
      onToggle={() => onSort(`${id}:${field === id && direction === 'asc' ? 'desc' : 'asc'}`)}
      className={right ? 'text-right' : undefined}
    >
      {label}
    </SortableTableHead>
  )
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Invoice</TableHead>
          {sortHead('issued', 'Issued')}
          <TableHead>Billed to</TableHead>
          <TableHead>Category</TableHead>
          {sortHead('amount', 'Amount', true)}
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <PortalInvoiceRow
            key={row.invoice_id}
            row={row}
            href={audience.preview ? null : portalInvoicePath(row)}
          >
            <TableCell className="whitespace-nowrap">{displayDate(row.issued_on)}</TableCell>
            <TableCell>
              <BilledTo row={row} />
            </TableCell>
            <TableCell className="capitalize">{row.category}</TableCell>
            <TableCell className="text-right font-medium tabular-nums">
              {row.net.formatted}
            </TableCell>
          </PortalInvoiceRow>
        ))}
      </TableBody>
    </Table>
  )
}
